module.exports = __webpack_public_path__ + "components/app-store/static/sfc-featured-a51dbf6dc1aaae7f8baf7b69eb4dce6d.jpg";